"use client";

import createSvgIcon from "@mui/material/utils/createSvgIcon";
export default createSvgIcon(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M17 7v4a5 5 0 0 1-10 0V7a5 5 0 0 1 10 0m0 0h-3m3 4h-3m6 0a8 8 0 0 1-8 8m0 0a8 8 0 0 1-8-8m8 8v3m0 0h3m-3 0H9" color="currentColor" />
  </svg>, "MicrophoneLines");